import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.online,
    props.user.online_timestamp,
    props.user.bonus_state,
    props.user.currency,
    props.user.buttons.take_bonus,
    props.user.user,
    (online, timestamp, bonus_state, currency, button, user) => {
        return {
            online,
            timestamp,
            bonus_state,
            currency,
            button,
            user
        }
    }
)